import { getData, postData, deleteRequest } from './api';

export interface CardDavPasswordInfo {
  id: string;
  name: string;
  lastUsedAt: string | null;
  createdAt: string;
  revokedAt: string | null;
}

export interface CreateCardDavPasswordResponse {
  id: string;
  name: string;
  password: string;
  createdAt: string;
  message: string;
}

export interface CardDavConnectionInfo {
  server: string;
  username: string;
  path: string;
  setupInstructions: {
    ios: string[];
  };
}

export async function listCardDavPasswords(): Promise<CardDavPasswordInfo[]> {
  return (await getData<{ passwords: CardDavPasswordInfo[] }>('/api/settings/carddav/passwords')).passwords;
}

export function createCardDavPassword(
  name: string
): Promise<CreateCardDavPasswordResponse> {
  return postData<CreateCardDavPasswordResponse, { name: string }>('/api/settings/carddav/passwords', { name });
}

export function revokeCardDavPassword(id: string): Promise<void> {
  return deleteRequest(`/api/settings/carddav/passwords/${id}`);
}

export function getCardDavConnectionInfo(): Promise<CardDavConnectionInfo> {
  return getData<CardDavConnectionInfo>('/api/settings/carddav/info');
}
